/* eslint-disable @typescript-eslint/interface-name-prefix */

export interface LogInterface {
    debug(primaryMessage: string, ...supportingData: any[]): void;
    warn(primaryMessage: string, ...supportingData: any[]): void;
    error(primaryMessage: string, ...supportingData: any[]): void;
    info(primaryMessage: string, ...supportingData: any[]): void;
}

export class Log implements LogInterface {
  public debug (msg: string, ...supportingDetails: any[]): void{
    this.emitLogMessage('debug', msg, supportingDetails)
  }

  public warn (msg: string, ...supportingDetails: any[]): void{
    this.emitLogMessage('warn', msg, supportingDetails)
  }

  public error (msg: string, ...supportingDetails: any[]): void{
    this.emitLogMessage('error', msg, supportingDetails)
  }

  public info (msg: string, ...supportingDetails: any[]): void{
    this.emitLogMessage('info', msg, supportingDetails)
  }

  private emitLogMessage (msgType: 'debug' | 'warn' | 'error' | 'info', msg: string, supportingDetails: any[]) {
    if (supportingDetails.length > 0) {
      return [msg, supportingDetails]
      // console.log(msg, supportingDetails)
    } else {
      return [msgType, msg]
      // console[msgType](msg)
    }
  }
}
